import $ from "jquery";
import Cookies from 'js-cookie';

const BannerNotice = (el) => {
    const $el = $(el);
    const $banner = $(".banner-notice");
    const bannerCookie = Cookies.get("banner-notice");

    if (!bannerCookie) {
        $banner.removeClass("banner-notice--closed");
    }

    $el.on("click", function (e) {
        const isClosed = $banner.hasClass("banner-notice--closed");

        if(window.CookieScript && CookieScript.instance) {
            const state = CookieScript.instance.currentState();
            const isAccepted = state?.categories.includes('functionality');

            if(isAccepted) {
                Cookies.set("banner-notice", "closed", { expires: 1 });
            } else {
                Cookies.remove("banner-notice");
            }
        }

        if(isClosed) {
            $banner.removeClass("banner-notice--closed");
            $el.attr('aria-expanded', 'true');
        } else {
            $banner.addClass("banner-notice--closed");
            $el.attr('aria-expanded', 'false');
        }

    });


};

export default BannerNotice;
